import { transformPhoneWithDash } from "@repo/utils/src/number";
import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
  name: string;
  province: string;
  address1: string;
  address2: string;
  phone: string;
  isDefaultAddress?: boolean;
  className?: string;
  children?: React.ReactNode;
}

function AddressItem({
  name,
  province,
  address1,
  address2,
  phone,
  isDefaultAddress = false,
  className,
  children,
}: IProps) {
  const { t } = useTranslation();

  return (
    <div className="flex w-full">
      <div className={classNames("w-full", className)}>
        {isDefaultAddress ? (
          <div className="mb-1 font-normal">
            <span>{t("account.shipping.address.default")}</span>
          </div>
        ) : null}
        <div className="font-regular">
          <span className="block">{name}</span>
          <span className="block">{province}</span>
          <span className="block">{address1}</span>
          <span className="block">{address2}</span>
          <span className="block">{transformPhoneWithDash(phone)}</span>
        </div>
      </div>
      {/* 우측 버튼 */}
      {children}
    </div>
  );
}

export default AddressItem;
